import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse } from 'dtos'
import { FedExShipmentDto } from 'dtos/fedEx'
import { MichiganOutgoingTitleDto, MichiganOutgoingTitleVehicleDto } from 'dtos/michiganOutgoingTitles'
import { URIQuery } from 'utils'

const baseUrl = (): string => '/api/michigan-outgoing-titles'
const guidUrl = (guid: string) => `${baseUrl()}/${encodeURIComponent(guid)}`

export const getMichiganOutgoingTitleVehicles = (
  michiganOutgoingTitleGuid: string,
  includeMichiganOutgoingTitleVehiclesAlreadyInAGroup: boolean,
  cancelToken?: CancelToken
) =>
  apiClient
    .get<ApiResponse<MichiganOutgoingTitleVehicleDto[]>>(
      `${guidUrl(michiganOutgoingTitleGuid)}/vehicles` + URIQuery({ includeMichiganOutgoingTitleVehiclesAlreadyInAGroup }),
      { cancelToken }
    )
    .then(res => res.data)

export const addVehiclesToMichiganOutgoingTitle = (michiganOutgoingTitleGuid: string, vehicles: MichiganOutgoingTitleVehicleDto[], cancelToken?: CancelToken) =>
  apiClient.post<ApiResponse<MichiganOutgoingTitleDto>>(`${guidUrl(michiganOutgoingTitleGuid)}/vehicles`, vehicles, { cancelToken }).then(res => res.data)

export const removeVehiclesFromMichiganOutgoingTitle = (
  michiganOutgoingTitleGuid: string,
  vehicles: MichiganOutgoingTitleVehicleDto[],
  cancelToken?: CancelToken
) => apiClient.delete<ApiResponse<MichiganOutgoingTitleDto>>(`${guidUrl(michiganOutgoingTitleGuid)}/vehicles`, { data: vehicles }).then(res => res.data)

export const getFedExShipment = (michiganOutgoingTitleGuid: string, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<FedExShipmentDto | undefined>>(`${guidUrl(michiganOutgoingTitleGuid)}/fedex-shipment`, { cancelToken }).then(res => res.data)

export const saveFedExShipment = (michiganOutgoingTitleGuid: string, values: FedExShipmentDto, cancelToken?: CancelToken) =>
  apiClient.put<ApiResponse<FedExShipmentDto>>(`${guidUrl(michiganOutgoingTitleGuid)}/fedex-shipment`, values, { cancelToken }).then(res => res.data)
